// store/reducers/sidebar.js
import { createSlice } from "@reduxjs/toolkit";

const sidebarSlice = createSlice({
  name: "sideMenu",
  initialState: false,
  reducers: {
    toggleMenu: (state) => !state,
    setMenu: (state, action) => action.payload,
  },
});

export const { toggleMenu, setMenu } = sidebarSlice.actions;
export const sideMenuReducer = sidebarSlice.reducer;
